import { useEffect, useMemo, useRef, useState } from 'react';

import { apiUrl, fetchJson } from '../../apiBase';

export default function useMaarifStudentPerformance({
  schoolId,
  classId,
  studentId,
  lessonId,
  enabled,
  notifyError,
}) {
  const [loading, setLoading] = useState(false);
  const [student, setStudent] = useState(null);
  const [tables, setTables] = useState([]);
  const reqIdRef = useRef(0);

  const requestBody = useMemo(
    () => ({
      school_id: schoolId,
      class_id: classId,
      student_id: studentId,
      lesson_id: lessonId ?? null,
    }),
    [schoolId, classId, studentId, lessonId]
  );

  useEffect(() => {
    setStudent(null);
    setTables([]);
    setLoading(false);

    if (!enabled || !schoolId || !classId || !studentId) return;

    const rid = ++reqIdRef.current;
    const run = async () => {
      setLoading(true);
      try {
        const res = await fetchJson(apiUrl('/admin/learning-activity-assessments/student-performance'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(requestBody),
        });
        if (rid !== reqIdRef.current) return;
        if (!res.ok) throw new Error('student-performance');

        const data = await res.json();
        setStudent(data?.student || null);
        setTables(Array.isArray(data?.tables) ? data.tables : []);
      } catch (e) {
        if (rid !== reqIdRef.current) return;
        notifyError && notifyError('Öğrenci performansı yüklenemedi');
        setStudent(null);
        setTables([]);
      } finally {
        if (rid !== reqIdRef.current) return;
        setLoading(false);
      }
    };

    run();
  }, [enabled, schoolId, classId, studentId, requestBody, notifyError]);

  return { loading, student, tables };
}
